import request from '@/utils/request'

export function getPageList(data) {
  return request({
    url: 'log/getPageList',
    method: 'post',
    data
  })
}